
import { defineComponent, onMounted, onUnmounted, reactive, toRefs } from "vue";
import HoriSlide from "@/components/horiSlide/HoriSlide.vue";
import {
  getResourceData,
  getCooperationList,
  getFarmingTaskData,
  getFarmingTaskCountApi,
  getFarmerFarmingList,
  delFarmingRecordApi,
} from "../../../api/farmer";
import { stateType } from "./homeType";
import { useRouter, Router } from "vue-router";
import wx from "weixin-js-sdk";

import { getConfigWeixin } from "@/utils/index";
import Throttle from "@/utils/throttle";
import FarmingTask from "@/components/farmingTask/farmingTask.vue";
import { Dialog, ImagePreview, Notify } from "vant";
import mitt from "@/utils/mitt";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import store from "@/store/index";
import Storage from "@/storage/Storage";
let throttle: Throttle;

const states = {
  page: 1,
  pageSize: 10,
  resourceData: [],
  farmingDataList: [],
  loading: false,
  cooperationData: [],
  cooperationDialog: false,
  selectedCooperation: {},
  cooperationIndex: 0,
  filterActive: 0,
  farmerId: "",
  sourceId: "",
  lat: 0,
  lng: 0,
  tagType: "task", // 默认选中农事记录
  showBack: false,
  outTimeDataCount: 0, // 逾期多少数据
  recordPage: 1,
  recordList: [],
  taskTotal: 0,
  recordTotal: 0,
  previewVideos: false,
  videoUrl: "",
};
export default defineComponent({
  components: {
    HoriSlide,
    FarmingTask,
    PreviewVideo,
  },
  setup() {
    const router = useRouter();
    const state = reactive<stateType>(states);
    const { getInitInfo } = useData(state);
    document.addEventListener("scroll", listenScroll);
    Storage.remove("tempMessageData");
    Storage.remove("tempSpaceData");
    // 监听滚动执行
    function listenScroll() {
      // 获取整个dom的总高度
      const sumHeight = document.body.scrollHeight;
      // 获取可是区域高度
      const clientHeight = document.body.clientHeight;
      // 获取滚动了多少像素
      const scrollHeight = document.documentElement.scrollTop;
      // 事件防抖
      throttle && throttle.search({ sumHeight, clientHeight, scrollHeight });
      // 滚动了一屏幕的高度后就显示返回顶部
      if (scrollHeight > clientHeight) {
        state.showBack = true;
      } else {
        state.showBack = false;
      }
    }

    // 进入到首页后 如果路由存在则跳转
    if (localStorage.getItem("tempRoute")) {
      router.push("/" + localStorage.getItem("tempRoute"));
      localStorage.removeItem("tempRoute");
      return;
    }
    // 获取定位权限
    getConfigWeixin(["getLocation"]);
    //执行方法
    wx.ready(function () {
      wx.getLocation({
        success: function (res: any) {
          state.lat = res.latitude; //纬度，浮点数，范围为90 ~ -90
          state.lng = res.longitude; //经度，浮点数，范围为180 ~ -180。
          store.commit("setLngLat", { lat: state.lat, lng: state.lng });
          getInitInfo();
        },
        fail: function (res: any) {
          Notify("获取位置失败");
          getInitInfo();
        },
      });
    });
    //config验证失败
    wx.error(function (res: any) {
      // Notify("获取凭据失败");
      // getInitInfo();
    });
    const { getFarmingDataList, getTaskCountData, getFarmingRecordData } =
      useData(state);
    // 监听页面回退回来
    mitt.on("recordUpdate", function () {
      state.page = 1;
      state.recordPage = 1;
      getFarmingDataList();
      getTaskCountData();
      getFarmingRecordData();
    });
    onUnmounted(() => {
      document.removeEventListener("scroll", listenScroll);
      mitt.off("recordUpdate");
    });
    return {
      ...toRefs(state),
      getInitInfo,
      ...useEvent(state, router),
      ...useOperation(state),
    };
  },
});

/**
 * 触发列表的事件
 */
const useOperation = (state: stateType) => {
  return {
    onPlayVideo: function (item: any) {
      state.videoUrl = item.url;
      state.previewVideos = true;
    },
    onDeleteRecord: async (item: any) => {
      const { deleteRecordData } = useData(state);
      Dialog.confirm({
        title: "提示",
        message: "确定删除吗？",
      }).then(() => {
        deleteRecordData(item.id);
      });
    },
  };
};

/**
 * 获取接口数据
 */
const useData = (state: stateType) => {
  // 删除记录数据
  const deleteRecordData = async (id: string) => {
    const result: any = await delFarmingRecordApi(id);
    if (result.data.code === 0) {
      Notify({ type: "success", message: "已删除" });
      state.recordPage = 1;
      state.page = 1;
      // 获取农事任务数据
      getFarmingDataList();
      // 获取农事记录数据
      getFarmingRecordData();
      // 获取统计
      getTaskCountData();
    }
  };
  // 获取农事记录数据列表
  const getFarmingRecordData = async () => {
    const result: any = await getFarmerFarmingList({
      page: state.recordPage,
      pageSize: 10,
      sourceId: state.sourceId,
    });
    if (result.data.code === 0) {
      let tempList = result.data.data.records.map((item: any) => {
        item.showMenu = false;
        item.workTimeStr = item.workTime
          ? item.workTime.replace(/-/g, ".")
          : "";
        return item;
      });
      state.recordTotal = result.data.data.total;
      if (state.recordPage === 1) {
        state.recordList = tempList;
      } else {
        state.recordList = state.recordList.concat(tempList);
      }
    }
  };
  // 获取任务统计数量
  const getTaskCountData = async () => {
    const result: any = await getFarmingTaskCountApi(state.sourceId);
    if (result.data.code === 0) {
      state.outTimeDataCount = result.data.data;
    }
  };
  const getInitInfo = () => {
    getCooperationData();
    throttle = new Throttle(
      500,
      ({
        sumHeight,
        clientHeight,
        scrollHeight,
      }: {
        sumHeight: number;
        clientHeight: number;
        scrollHeight: number;
      }) => {
        // 计算滚动到底部  可视区域高度+滚动的像素 等于了整个dom高度就相当于触底了，但需要预留一些高度，只要小于了预留高度就算它触底，预留的高度为10像素
        if (sumHeight - (clientHeight + scrollHeight) < 10) {
          if (state.farmerId && state.sourceId) {
            if (
              state.tagType === "task" &&
              state.taskTotal !== state.farmingDataList.length
            ) {
              ++state.page;
              getFarmingDataList();
            } else if (
              state.tagType === "record" &&
              state.recordTotal !== state.recordList.length
            ) {
              ++state.recordPage;
              getFarmingRecordData();
            }
          }
        }
      }
    );
  };
  // 获取合作社
  const getCooperationData = async () => {
    const result: any = await getCooperationList();
    if (result.data.code == 0) {
      state.cooperationData = result.data.data.map((item: any) => {
        item.text = item.cooperationName;
        return item;
      });
      // 合作社没有存在于缓存中时，默认选中第一个
      const tempData =
        localStorage.getItem("cooperationData") == "undefined" ||
        !localStorage.getItem("cooperationData")
          ? "{}"
          : (localStorage.getItem("cooperationData") as string);
      if (Object.keys(JSON.parse(tempData)).length > 0) {
        state.selectedCooperation = JSON.parse(tempData);
      } else {
        state.selectedCooperation = result.data.data[0];
        localStorage.setItem(
          "cooperationData",
          JSON.stringify(result.data.data[0])
        );
      }

      state.cooperationIndex = state.cooperationData.findIndex((item: any) => {
        return item.id == state.selectedCooperation.id;
      });
      getResourceDataList();
    }
  };
  const getFarmingDataList = async () => {
    // 获取农事任务数据列表
    const result: any = await getFarmingTaskData({
      page: state.page,
      pageSize: state.pageSize,
      areaId: "",
      status: state.filterActive,
      farmerId: state.farmerId,
      sourceId: state.sourceId,
    });
    if (result.data.code == 0) {
      const list = result.data.data.records;
      state.taskTotal = result.data.data.total;
      if (state.page === 1) {
        state.farmingDataList = list;
      } else {
        state.farmingDataList = state.farmingDataList.concat(list);
      }
    }
  };

  const getResourceDataList = async () => {
    const result: any = await getResourceData({
      lat: state.lat,
      lng: state.lng,
    });
    if (result.data.code == 0) {
      state.resourceData = result.data.data.records;
      // 默认取值第一个去获取数据
      state.farmerId =
        state.resourceData.length > 0 ? state.resourceData[0].farmerId : "";
      state.sourceId =
        state.resourceData.length > 0 ? state.resourceData[0].id : "";
      if (state.farmerId && state.sourceId) {
        // 获取农事任务数据
        getFarmingDataList();
        // 获取农事记录数据
        getFarmingRecordData();
        // 获取统计
        getTaskCountData();
      }
    }
  };
  return {
    getFarmingDataList,
    getResourceDataList,
    getCooperationData,
    getInitInfo,
    getTaskCountData,
    deleteRecordData,
    getFarmingRecordData,
  };
};

/**
 * 事件类hooks
 */
const useEvent = (state: stateType, router: Router) => {
  const {
    getFarmingDataList,
    getResourceDataList,
    getTaskCountData,
    getFarmingRecordData,
  } = useData(state);
  const onEditRecord = (item: any) => {
    // 在这个记录的数据里面没有status和recordId 这个记录数据的id就是recordId
    // 所以为了和农事任务那边的情况保持一致，这里手动添加两个属性，跳转之后编辑页面会用到。否则编辑页面会根据这个情况写两套逻辑
    //实属无奈
    item.optionRecordId = item.id;
    item.status = 1;
    router.push({
      path: "/updateFarming",
      query: {
        sourceId: state.sourceId,
        item: JSON.stringify(item),
      },
    });
  };
  const onPreview = (l: Array<any>, i: number) => {
    let strArr = l.map((item) => item.url);
    ImagePreview({ images: strArr, startPosition: i });
  };
  const onShowMenu = (datas: any) => {
    // 重置一下其他的item
    state.recordList.forEach((item) => {
      if (item.id !== datas.id) {
        item.showMenu = false;
      }
    });

    datas.showMenu = !datas.showMenu;
  };

  const onBack = () => {
    // 保存像素
    let scrollTop = document.documentElement.scrollTop;
    const timer = setInterval(() => {
      if (scrollTop <= 0) {
        clearInterval(timer);
      }
      document.documentElement.scrollTop = scrollTop -= 50;
    }, 10);
  };
  const onClickRecord = () => {
    state.tagType = "record";
  };
  const onClickTask = () => {
    state.tagType = "task";
  };
  const onRecordFarming = () => {
    router.push({
      path: '"/updateFarming',
      query: {
        sourceId: state.sourceId,
      },
    });
  };
  const onUpdateTask = () => {
    state.page = 1;
    getFarmingDataList();
  };
  const onActiveChange = (e: number) => {
    state.filterActive = e;
    if (state.farmerId && state.sourceId) {
      state.page = 1;
      getFarmingDataList();
    }
  };
  const onSourceChange = (e: any) => {
    // 在切换swiper的时候 下面的农事任务数据需要跟着一起联动，因此重新赋值id请求对应的数据
    state.farmerId = state.resourceData[e].farmerId;
    state.sourceId = state.resourceData[e].id;
    if (state.farmerId && state.sourceId) {
      state.page = 1;
      getFarmingDataList();
      getTaskCountData();
      getFarmingRecordData();
    }
  };
  const onCancel = () => {
    state.cooperationDialog = false;
  };
  const onConfirm = (e: any) => {
    // 在登录成功后的所有接口中，header都要带上cooperationId，这个字段是后端所需要的
    // 当切换合作社的时候，就要把copperationId更新一下，并重新请求新的数据
    // if (state.farmerId && state.sourceId) {
    state.selectedCooperation = e;
    localStorage.setItem("cooperationData", JSON.stringify(e));
    state.page = 1;
    getResourceDataList();

    state.cooperationDialog = false;
    // }
  };
  // 点击切换按钮
  const onSwitch = () => {
    state.cooperationDialog = true;
  };
  const onRefresh = () => {
    // 下拉刷新
    if (state.sourceId && state.farmerId) {
      state.loading = true;
      state.page = 1;
      state.recordPage = 1;
      // 获取农事任务数据
      getFarmingDataList();
      // 获取农事记录数据
      getFarmingRecordData();
      // 获取统计
      getTaskCountData();
      const timer = setTimeout(() => {
        state.loading = false;
        clearTimeout(timer);
      }, 1000);
    }
  };

  const onAdd = () => {
    router.push("/addResource");
  };

  const onClickSource = (e: any) => {
    router.push({
      path: "/baseManage/" + e.id,
    });
  };

  return {
    onAdd,
    onClickSource,
    onRefresh,
    onUpdateTask,
    onCancel,
    onActiveChange,
    onSourceChange,
    onConfirm,
    onRecordFarming,
    onSwitch,
    onClickRecord,
    onClickTask,
    onBack,
    onShowMenu,
    onPreview,
    onEditRecord,
  };
};
